import { leaveBreadcrumb } from 'cfa-react-logging';
import authClient from '../authClient';
import ooeConstants from '../constants';
import { handleFetchFail, throwIfNotOk } from '../util/httpUtils';

export const deleteOrderReport = async ({
  locationNumber,
  orderId,
  cfaId,
}: {
  orderId: string;
  locationNumber: string;
  cfaId: string;
}): Promise<void> => {
  const baseUrl = ooeConstants.URL.ORDERS;
  const url = `${baseUrl}/reports/1.0/location/${locationNumber}/${orderId}/${cfaId}`;
  const method = 'DELETE';
  const bugsnag = {
    breadcrumb: `Delete Report for Order ID ${orderId}`,
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_ORDERS,
    context: 'Delete Order Report',
    info: {
      orderId,
      locationNumber,
      cfaId,
    },
  };

  leaveBreadcrumb(bugsnag.breadcrumb, {
    url,
    method,
    context: bugsnag.context,
    info: bugsnag.info,
  });

  const apiKey = await authClient.getOrRenewAccessToken();
  const headers = { Authorization: `JWTBearer ${apiKey}` };
  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  await throwIfNotOk(response);
};
